import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-link',
  templateUrl: './ui-link.component.html',
  styleUrls: ['./ui-link.component.scss']
})
export class UILinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
